
import { UserRepository } from "@api/repositories/UserRepository";
import { getBackend } from "@service/router/getters";
import { Session } from "@service/types/Session";
import { Vue, Component } from "vue-property-decorator";

@Component({})

export default class LoginLogic extends Vue {
    userRepository: UserRepository = this.$repositories.get('user');

    async loggedIn(session: Session) {
        this.$store.dispatch('setSession', {data: session});

        const user = await this.userRepository.user(session.userId);
        this.$store.dispatch('setSessionLanguage', user?.language ? user?.language : this.lang);

        if(!window.google_tag_manager) {
            await this.$analytics.bootstrap(this.$gtag);
        }
        this.$analytics.setGtagParams(true, false);

        await this.$store.dispatch('fetchInitData', {
            backend: getBackend(this.$route.params.backend),
            afterLogin: true
        });

        if (this.afterLoginPath) {
            this.$router.push(this.afterLoginPath);
        }
        else {
            this.$router.push({name: 'Home', params: this.$route.params});
        }
    }

    get afterLoginPath() {
        return this.$store.state.afterLoginPath;
    }

    get lang(): string {
        return this.$store.state.session?.language || navigator.language.split('-')[0] || "ru";
    }
}

